import { render } from "./AddSupplier.vue?vue&type=template&id=195ee430&scoped=true"
import script from "./AddSupplier.vue?vue&type=script&lang=js"
export * from "./AddSupplier.vue?vue&type=script&lang=js"

import "./AddSupplier.vue?vue&type=style&index=0&id=195ee430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-195ee430"]])

export default __exports__